import { render, staticRenderFns } from "./StudioBookingFreistaat.vue?vue&type=template&id=796009f5&"
import script from "./StudioBookingFreistaat.vue?vue&type=script&lang=js&"
export * from "./StudioBookingFreistaat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports